import MultiAutocomplete from './MultiAutocomplete';

export default MultiAutocomplete;
